// Put your application javascript here
document.documentElement.classList.add("motion-ready");

document.addEventListener("DOMContentLoaded", function () {
  // Navigation must initialize before optional page animation/carousel libraries.
  initializeMobileMenu();
  initializeCatalogueMenus();
  initializeCardGridScrollFocus();
  initializeScrollReveals();

  // Initial Glide setup on page load
  initializeGlides();

  // Update the cart badge when the page loads
  updateCartQuantityBadge();

  // AOS.init();
  AOS.init({
    offset: 25, // Adjust this value to trigger animation sooner or later
    duration: 500, // Animation duration
    easing: "ease-in-out", // The easing function for animation
  });

  // Re-initialize in Shopify design mode with full reset for Glides
  if (Shopify.designMode) {
    const syncGlideToBlock = (blockId) => {
      document.querySelectorAll(".glide").forEach((carousel) => {
        const glide = glideInstances[carousel.id] || mountGlide(carousel);
        if (!glide) return;

        annotateGlideSlides(carousel);

        const targetSlide = Array.from(
          carousel.querySelectorAll(".glide__slide")
        ).find(
          (slide) =>
            !slide.classList.contains("glide__slide--clone") &&
            slide.dataset.blockId === blockId
        );
        if (!targetSlide || targetSlide.dataset.glideIndex === undefined) return;

        const targetIndex = Number(targetSlide.dataset.glideIndex);
        glide.go("=" + targetIndex);
        glide.pause();
        glide.update({ autoplay: false, hoverpause: false });
      });
    };

    const designerRefresh = () => {
      document.querySelectorAll(".glide").forEach((carousel) => {
        const glide = mountGlide(carousel);
      });

      // Refresh AOS animations
      AOS.refreshHard();
      initializeMobileMenu();
      initializeCatalogueMenus();
      initializeCardGridScrollFocus();
      initializeScrollReveals();
    };

    document.addEventListener("shopify:section:load", designerRefresh);
    document.addEventListener("shopify:section:unload", designerRefresh);
    document.addEventListener("shopify:block:select", (event) =>
      syncGlideToBlock(event.detail.blockId)
    );
    document.addEventListener("shopify:block:deselect", designerRefresh);
  }
});

function initializeScrollReveals() {
  const elements = Array.from(
    document.querySelectorAll("[data-scroll-reveal]:not([data-reveal-initialized])")
  );

  if (!elements.length) return;

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  if (reducedMotion.matches || !("IntersectionObserver" in window)) {
    elements.forEach((element) => {
      element.dataset.revealInitialized = "true";
      element.classList.add("is-revealed");
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle("is-revealed", entry.isIntersecting);
      });
    },
    {
      rootMargin: "0px 0px -10% 0px",
      threshold: 0.08,
    }
  );

  elements.forEach((element) => {
    element.dataset.revealInitialized = "true";
    observer.observe(element);
  });
}

function initializeCardGridScrollFocus() {
  if (window.cardGridScrollFocusInitialized) {
    window.dispatchEvent(new Event("scroll"));
    return;
  }

  window.cardGridScrollFocusInitialized = true;

  const mobileViewport = window.matchMedia("(max-width: 39.999rem)");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let animationFrame;

  const updateFocusedCards = () => {
    animationFrame = undefined;

    const grids = document.querySelectorAll("[data-card-grid]");
    const shouldAnimate = mobileViewport.matches && !reducedMotion.matches;
    const viewportCenter = window.innerHeight / 2;
    const focusZoneTop = window.innerHeight * 0.28;
    const focusZoneBottom = window.innerHeight * 0.72;

    grids.forEach((grid) => {
      const items = Array.from(grid.querySelectorAll("[data-card-grid-item]"));

      if (!shouldAnimate) {
        items.forEach((item) => item.classList.remove("is-scroll-focused"));
        return;
      }

      const focusCandidates = items.filter((item) => {
        const itemRect = item.getBoundingClientRect();
        return itemRect.bottom >= focusZoneTop && itemRect.top <= focusZoneBottom;
      });

      if (!focusCandidates.length) {
        items.forEach((item) => item.classList.remove("is-scroll-focused"));
        return;
      }

      const focusedItem = focusCandidates.reduce(
        (closestItem, item) => {
          const itemRect = item.getBoundingClientRect();
          const itemCenter = itemRect.top + itemRect.height / 2;
          const closestRect = closestItem.getBoundingClientRect();
          const closestCenter = closestRect.top + closestRect.height / 2;

          return Math.abs(itemCenter - viewportCenter) <
            Math.abs(closestCenter - viewportCenter)
            ? item
            : closestItem;
        }
      );

      items.forEach((item) =>
        item.classList.toggle("is-scroll-focused", item === focusedItem)
      );
    });
  };

  const requestUpdate = () => {
    if (animationFrame !== undefined) return;
    animationFrame = window.requestAnimationFrame(updateFocusedCards);
  };

  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate, { passive: true });

  if (typeof mobileViewport.addEventListener === "function") {
    mobileViewport.addEventListener("change", requestUpdate);
    reducedMotion.addEventListener("change", requestUpdate);
  } else {
    mobileViewport.addListener(requestUpdate);
    reducedMotion.addListener(requestUpdate);
  }

  requestUpdate();
}

function initializeMobileMenu() {
  const toggle = document.querySelector("[data-mobile-menu-toggle]");
  const panel = document.getElementById("navbar-sticky");
  const header = toggle?.closest("header");

  if (!toggle || !panel || !header || toggle.dataset.menuInitialized) return;

  toggle.dataset.menuInitialized = "true";

  const desktopViewport = window.matchMedia("(min-width: 64rem)");
  let isOpen = false;

  const setOpen = (open, returnFocus = false) => {
    isOpen = Boolean(open && !desktopViewport.matches);

    panel.dataset.open = String(isOpen);
    panel.setAttribute(
      "aria-hidden",
      String(!desktopViewport.matches && !isOpen)
    );
    panel.toggleAttribute("inert", !desktopViewport.matches && !isOpen);
    toggle.setAttribute("aria-expanded", String(isOpen));
    document.documentElement.classList.toggle("mobile-menu-open", isOpen);

    if (!isOpen) {
      document.dispatchEvent(new CustomEvent("mobile-menu:closed"));
    }

    if (returnFocus) toggle.focus();
  };

  toggle.addEventListener("click", () => setOpen(!isOpen));

  panel.addEventListener("click", (event) => {
    if (event.target === panel) setOpen(false, true);
  });

  panel.querySelectorAll("a[href]").forEach((link) => {
    link.addEventListener("click", () => setOpen(false));
  });

  document.addEventListener("keydown", (event) => {
    if (!isOpen) return;

    if (event.key === "Escape") {
      event.preventDefault();
      setOpen(false, true);
      return;
    }

    if (event.key !== "Tab") return;

    const focusableElements = Array.from(
      header.querySelectorAll('a[href], button:not([disabled])')
    ).filter((element) => element.getClientRects().length > 0);

    if (focusableElements.length === 0) return;

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstFocusable) {
      event.preventDefault();
      lastFocusable.focus();
    } else if (!event.shiftKey && document.activeElement === lastFocusable) {
      event.preventDefault();
      firstFocusable.focus();
    }
  });

  if (typeof desktopViewport.addEventListener === "function") {
    desktopViewport.addEventListener("change", () => setOpen(false));
  } else {
    desktopViewport.addListener(() => setOpen(false));
  }

  setOpen(false);
}

function initializeCatalogueMenus() {
  const header = document.querySelector(".site-header");
  const desktopTrigger = header?.querySelector("[data-catalogue-trigger]");
  const desktopPanel = header?.querySelector("[data-catalogue-mega-menu]");
  const mobileToggle = header?.querySelector("[data-mobile-catalogue-toggle]");
  const mobilePanel = header?.querySelector("[data-mobile-catalogue-panel]");

  if (!header || header.dataset.catalogueInitialized) return;
  header.dataset.catalogueInitialized = "true";

  const desktopViewport = window.matchMedia("(min-width: 64rem)");
  const categoryTabs = Array.from(
    header.querySelectorAll("[data-catalogue-category]")
  );
  const productPanels = Array.from(
    header.querySelectorAll("[data-catalogue-products-panel]")
  );
  const mobileCategories = Array.from(
    header.querySelectorAll("[data-mobile-catalogue-category]")
  );
  let closeTimer;

  const setDesktopOpen = (open) => {
    if (!desktopTrigger || !desktopPanel) return;

    const nextOpen = Boolean(open && desktopViewport.matches);
    desktopPanel.dataset.open = String(nextOpen);
    desktopPanel.setAttribute("aria-hidden", String(!nextOpen));
    desktopPanel.toggleAttribute("inert", !nextOpen);
    desktopTrigger.setAttribute("aria-expanded", String(nextOpen));
  };

  const cancelClose = () => window.clearTimeout(closeTimer);
  const scheduleClose = () => {
    cancelClose();
    closeTimer = window.setTimeout(() => setDesktopOpen(false), 140);
  };

  const setActiveCategory = (categoryId, focusTab = false) => {
    categoryTabs.forEach((tab) => {
      const active = tab.dataset.catalogueCategory === categoryId;
      tab.dataset.active = String(active);
      tab.setAttribute("aria-selected", String(active));
      tab.tabIndex = active ? 0 : -1;
      if (active && focusTab) tab.focus();
    });

    productPanels.forEach((panel) => {
      const active = panel.dataset.catalogueProductsPanel === categoryId;
      panel.dataset.active = String(active);
      panel.setAttribute("aria-hidden", String(!active));
    });
  };

  if (desktopTrigger && desktopPanel) {
    desktopTrigger.addEventListener("pointerenter", () => {
      cancelClose();
      setDesktopOpen(true);
    });
    desktopTrigger.addEventListener("pointerleave", scheduleClose);
    desktopTrigger.addEventListener("focus", () => setDesktopOpen(true));
    desktopPanel.addEventListener("pointerenter", cancelClose);
    desktopPanel.addEventListener("pointerleave", scheduleClose);
  }

  categoryTabs.forEach((tab, index) => {
    const activate = () => setActiveCategory(tab.dataset.catalogueCategory);
    tab.addEventListener("pointerenter", activate);
    tab.addEventListener("focus", activate);
    tab.addEventListener("click", activate);
    tab.addEventListener("keydown", (event) => {
      if (!["ArrowDown", "ArrowUp", "ArrowRight", "ArrowLeft"].includes(event.key)) {
        return;
      }

      event.preventDefault();
      const step = ["ArrowDown", "ArrowRight"].includes(event.key) ? 1 : -1;
      const nextIndex = (index + step + categoryTabs.length) % categoryTabs.length;
      setActiveCategory(
        categoryTabs[nextIndex].dataset.catalogueCategory,
        true
      );
    });
  });

  const setMobileOpen = (open) => {
    if (!mobileToggle || !mobilePanel) return;

    const nextOpen = Boolean(open && !desktopViewport.matches);
    mobileToggle.setAttribute("aria-expanded", String(nextOpen));
    mobilePanel.dataset.open = String(nextOpen);
    mobilePanel.setAttribute("aria-hidden", String(!nextOpen));
    mobilePanel.toggleAttribute("inert", !nextOpen);

    if (!nextOpen) {
      mobileCategories.forEach((category) => {
        category.open = false;
      });
    }
  };

  mobileToggle?.addEventListener("click", () => {
    setMobileOpen(mobileToggle.getAttribute("aria-expanded") !== "true");
  });

  mobileCategories.forEach((category) => {
    category.addEventListener("toggle", () => {
      if (!category.open) return;
      mobileCategories.forEach((otherCategory) => {
        if (otherCategory !== category) otherCategory.open = false;
      });
    });
  });

  document.addEventListener("focusin", (event) => {
    if (
      desktopPanel?.dataset.open === "true" &&
      !desktopTrigger?.contains(event.target) &&
      !desktopPanel.contains(event.target)
    ) {
      setDesktopOpen(false);
    }
  });

  document.addEventListener("pointerdown", (event) => {
    if (
      desktopPanel?.dataset.open === "true" &&
      !desktopTrigger?.contains(event.target) &&
      !desktopPanel.contains(event.target)
    ) {
      setDesktopOpen(false);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    if (desktopPanel?.dataset.open === "true") {
      event.preventDefault();
      setDesktopOpen(false);
      desktopTrigger.focus();
    } else if (mobilePanel?.dataset.open === "true") {
      setMobileOpen(false);
      mobileToggle.focus();
    }
  });

  document.addEventListener("mobile-menu:closed", () => setMobileOpen(false));

  const handleViewportChange = () => {
    setDesktopOpen(false);
    setMobileOpen(false);
  };

  if (typeof desktopViewport.addEventListener === "function") {
    desktopViewport.addEventListener("change", handleViewportChange);
  } else {
    desktopViewport.addListener(handleViewportChange);
  }
}

function updateCartQuantityBadge() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const cartBadge = document.getElementById("cart-quantity-badge");
      if (cartBadge) {
        const previousCount = Number.parseInt(cartBadge.textContent, 10) || 0;
        const nextCount = cart.item_count || 0;
        const quantityChanged = previousCount !== nextCount;

        cartBadge.textContent = nextCount || "";
        cartBadge.classList.toggle("hidden", nextCount === 0);

        if (
          quantityChanged &&
          nextCount > 0 &&
          !window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ) {
          cartBadge.classList.remove("cart-badge-pop");
          void cartBadge.offsetWidth;
          cartBadge.classList.add("cart-badge-pop");
          cartBadge.addEventListener(
            "animationend",
            () => cartBadge.classList.remove("cart-badge-pop"),
            { once: true }
          );
        }
      }
    })
    .catch((error) =>
      console.error("Error updating cart quantity badge:", error)
    );
}

// Store each Glide carousel’s configuration
const glideConfigurations = {
  "#hero-carousel": {
    type: "carousel",
    autoplay: 5000,
    perView: 1,
    gap: 0,
    hoverpause: true,
  },
  "#featured-products-carousel": {
    type: "carousel",
    perView: 3,
    gap: 0,
    breakpoints: {
      1024: { perView: 2 },
      640: { perView: 1 },
    },
  },
  "#compact-products-carousel": {
    type: "carousel",
    perView: 3,
    gap: 0,
    breakpoints: {
      1024: {
        perView: 3,
      },
      768: {
        perView: 2,
      },
      460: {
        perView: 1,
      },
    },
  },
  "#card-carousel": {
    type: "carousel",
    focusAt: "center",
    perView: 1,
    gap: -25,
    peek: 330,
    breakpoints: {
      1024: {
        perView: 1,
        peek: 275,
      },
      960: {
        perView: 1,
        peek: 225,
      },
      900: {
        perView: 1,
        peek: 200,
      },
      800: {
        perView: 1,
        peek: 150,
      },
      700: {
        perView: 1,
        peek: 150,
      },
      600: {
        perView: 1,
        peek: 80,
      },
      525: {
        perView: 1,
        peek: 50,
      },
      450: {
        perView: 1,
        peek: 30,
      },
    },
  },
  "#image-gallery": {
    type: "carousel",
    perView: 3, // Allows Glide to adapt to content width
    gap: 50, // Adjust spacing between cards
    swipeThreshold: 80, // Disable swipe threshold for smoother scrolling
    dragThreshold: 80,
    animationDuration: 500,
    breakpoints: {
      1000: { perView: 2 },
      640: { perView: 1 },
    },
  },
  "#testimonial-carousel": {
    type: "carousel",
    perView: 2, // Allows Glide to adapt to content width
    gap: 50, // Adjust spacing between cards
    swipeThreshold: 80, // Disable swipe threshold for smoother scrolling
    dragThreshold: 80,
    animationDuration: 500,
    breakpoints: {
      1024: { perView: 2 },
      576: { perView: 1 },
    },
  },
};

// Track live Glide instances by carousel id
const glideInstances = {};
const isDesignMode =
  typeof Shopify !== "undefined" && Shopify.designMode === true;

function buildGlideConfig(carousel) {
  const baseConfig = glideConfigurations[`#${carousel.id}`];
  if (!baseConfig) return null;

  // Deep clone to avoid mutating the shared config object
  const config = JSON.parse(JSON.stringify(baseConfig));

  const autoplayAttr = carousel.dataset.autoplay;
  if (autoplayAttr !== undefined) {
    const parsedAutoplay = parseInt(autoplayAttr, 10);
    if (!Number.isNaN(parsedAutoplay)) {
      config.autoplay = parsedAutoplay === 0 ? false : parsedAutoplay;
    }
  }

  // In the editor, force autoplay off so slides don't advance while editing
  if (isDesignMode) {
    config.autoplay = false;
    config.hoverpause = false;
  }

  return config;
}

function annotateGlideSlides(carousel) {
  const slides = Array.from(carousel.querySelectorAll(".glide__slide"));
  let index = 0;

  slides.forEach((slide) => {
    if (slide.classList.contains("glide__slide--clone")) {
      delete slide.dataset.glideIndex;
    } else {
      slide.dataset.glideIndex = index;
      index += 1;
    }
  });
}

function mountGlide(carousel) {
  const config = buildGlideConfig(carousel);
  if (!config) return null;

  // Tear down any existing instance on this carousel
  if (glideInstances[carousel.id]) {
    glideInstances[carousel.id].destroy();
  }

  const glide = new Glide(carousel, config);
  glide.mount();
  annotateGlideSlides(carousel);
  glideInstances[carousel.id] = glide;

  // Freeze autoplay in the editor
  if (isDesignMode) {
    glide.pause();
    glide.update({ autoplay: false, hoverpause: false });
  }

  const overlaySlideCounts = {
    "testimonial-carousel": [1, ".slide_card"],
    "image-gallery": [2, ".slide_card"],
    "card-carousel": [1, ".card_carousel"],
  };

  const [slideCount, targetClass] = overlaySlideCounts[carousel.id] || [];
  if (slideCount !== undefined) {
    applyOverlayEffect(glide, carousel, slideCount, targetClass);
  }

  return glide;
}

function initializeGlides() {
  document.querySelectorAll(".glide").forEach((carousel) => {
    mountGlide(carousel);
  });
}

function applyOverlayEffect(glide, carousel, slideCount, targetClass) {
  const slides = Array.from(carousel.querySelectorAll(".glide__slide"));

  // Initial overlay setup
  setupOverlay(slides, slideCount, targetClass);

  // Transition animations before movement
  glide.on("run.before", (event) =>
    handleBeforeTransition(slides, slideCount, targetClass, event.direction)
  );

  // Final state cleanup after movement
  glide.on("run.after", () => finalizeOverlay(slides, slideCount, targetClass));
}

// Helper: Find active index
function getActiveIndex(slides) {
  return slides.findIndex((slide) =>
    slide.classList.contains("glide__slide--active")
  );
}

// Helper: Reset all slides
function resetSlides(slides, targetClass) {
  slides.forEach((slide) => {
    const contentDiv = slide.querySelector(targetClass);
    if (contentDiv) {
      contentDiv.classList.remove("active");
      contentDiv.style.transition = "none"; // Disable transition for cleanup
    }
  });
}

// Initial setup for overlay state
function setupOverlay(slides, slideCount, targetClass) {
  resetSlides(slides, targetClass); // Ensure clean state
  const activeIndex = getActiveIndex(slides);

  for (let i = 0; i < slideCount; i++) {
    const slide = getSlideAt(slides, activeIndex + i);
    toggleOverlayClass(slide, targetClass, true, false); // No transition for initial setup
  }
}

// Handle transitions during `run.before`
function handleBeforeTransition(slides, slideCount, targetClass, direction) {
  const activeIndex = getActiveIndex(slides);

  if (direction === ">") {
    const leavingSlide = getSlideAt(slides, activeIndex);
    const enteringSlide = getSlideAt(slides, activeIndex + slideCount);
    toggleOverlayClass(leavingSlide, targetClass, false, true); // Transition out
    toggleOverlayClass(enteringSlide, targetClass, true, true); // Transition in
  } else if (direction === "<") {
    const leavingSlide = getSlideAt(slides, activeIndex + slideCount - 1);
    const enteringSlide = getSlideAt(slides, activeIndex - 1);
    toggleOverlayClass(leavingSlide, targetClass, false, true); // Transition out
    toggleOverlayClass(enteringSlide, targetClass, true, true); // Transition in
  }
}

// Finalize overlay state during `run.after`
function finalizeOverlay(slides, slideCount, targetClass) {
  resetSlides(slides, targetClass); // Remove unnecessary classes
  const activeIndex = getActiveIndex(slides);

  for (let i = 0; i < slideCount; i++) {
    const slide = getSlideAt(slides, activeIndex + i);
    toggleOverlayClass(slide, targetClass, true, false); // Finalize without transitions
  }
}

// Safely get a slide at a given index (handles wrapping)
function getSlideAt(slides, index) {
  const totalSlides = slides.length;
  return slides[(index + totalSlides) % totalSlides];
}

// Toggle the `active` class with optional transitions
function toggleOverlayClass(
  slide,
  targetClass,
  shouldAdd,
  useTransition = false
) {
  const contentDiv = slide?.querySelector(targetClass);
  if (contentDiv) {
    contentDiv.style.transition = useTransition
      ? "all 0.3s ease-in-out"
      : "none";
    contentDiv.classList.toggle("active", shouldAdd);
  }
}

window.onload = () => {
  const sections = document.querySelectorAll("[data-section-id]");

  sections.forEach((section) => {
    const containers = section.querySelectorAll(".image-container");

    containers.forEach((container) => {
      const img = container.querySelector("img");

      if (img.complete) {
        container.classList.add("block-img-loaded");
      } else {
        img.addEventListener("load", () => {
          container.classList.add("block-img-loaded");
        });
      }
    });
  });
};
